module.exports = __webpack_public_path__ + "assets/img/18_188.b6d749b4.jpg";